import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Dialog } from '@material-ui/core';

const styles = {
  container: {
    width: 80,
    height: 60,
    borderRadius: 6,
    overflow: 'hidden',
    border: '1px solid #e0e0e0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fff',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
    cursor: 'pointer',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    display: 'block',
    borderRadius: 6,
  },
  fullImage: {
    maxWidth: '95vw',
    maxHeight: '95vh',
    width: 'auto',
    height: 'auto',
    display: 'block',
    margin: 'auto',
    width: '100%',
  },
};

const ImageField = ({ model, classes }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [open, setOpen] = useState(false);
  const image = model && model.attachments && model.attachments[0];

  //No image → return empty column
  if (!image || !image.filePath) {
    return '';
  }

  return (
    <>
      <div className={classes.container} onClick={() => setOpen(true)}>
        <img
          src={image.filePath}
          alt="Product"
          className={classes.image}
          style={{ display: isLoaded ? 'block' : 'none' }}
          onLoad={() => setIsLoaded(true)}
          onError={() => setIsLoaded(true)}
        />
      </div>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth={false}
        PaperProps={{
          style: {
            maxWidth: '95vw',
            width: 'auto',
          },
        }}
      >
        <img src={image.filePath} alt="Full size" className={classes.fullImage} />
      </Dialog>
    </>
  );
};

export default withStyles(styles)(ImageField);
